(() => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const isFinePointer = () => window.matchMedia('(pointer: fine)').matches;
  const root = document.documentElement;

  const updateOpenStateClass = () => {
    try {
      const anyOpen = document.querySelector('details.jr-mega-menu[open]');
      root.classList.toggle('jr-mega-open', !!anyOpen);
    } catch {
      // ignore
    }
  };

  const setHeaderPositionVars = () => {
    const header = document.querySelector('.header-wrapper .header') || document.querySelector('.header-wrapper');
    if (!(header instanceof HTMLElement)) return;
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--jr-header-left', `${Math.floor(rect.left)}px`);
    document.documentElement.style.setProperty('--jr-header-width', `${Math.floor(rect.width)}px`);
    document.documentElement.style.setProperty('--jr-header-bottom', `${Math.floor(rect.bottom)}px`);
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(rect.bottom)}px`);
  };

  const scheduleHeaderVarsUpdate = (() => {
    let raf = 0;
    return () => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        if (!isDesktop()) return;
        const anyOpen = document.querySelector('details.jr-mega-menu[open]');
        if (!anyOpen) return;
        setHeaderPositionVars();
      });
    };
  })();

  const activate = (detailsEl, key) => {
    if (!(detailsEl instanceof HTMLDetailsElement)) return;
    const content = detailsEl.querySelector('.jr-mega-menu__content');
    if (!(content instanceof HTMLElement)) return;

    const links = Array.from(detailsEl.querySelectorAll('[data-jr-mega-l2]')).filter((x) => x instanceof HTMLAnchorElement);
    const panels = Array.from(detailsEl.querySelectorAll('[data-jr-mega-panel]')).filter((x) => x instanceof HTMLElement);
    if (!key) return;

    links.forEach((a) => {
      const aKey = a.getAttribute('data-jr-mega-l2') || '';
      const active = aKey === key;
      a.classList.toggle('is-active', active);
    });

    panels.forEach((p) => {
      const pKey = p.getAttribute('data-jr-mega-panel') || '';
      const active = pKey === key;
      p.hidden = !active;
      p.classList.toggle('is-active', active);
    });
  };

  const openDetails = (detailsEl) => {
    if (!isDesktop()) return;
    if (!(detailsEl instanceof HTMLDetailsElement)) return;

    setHeaderPositionVars();

    detailsEl.setAttribute('open', '');
    updateOpenStateClass();
    const summary = detailsEl.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');

    const content = detailsEl.querySelector('.jr-mega-menu__content');
    const defaultKey =
      (content instanceof HTMLElement ? content.getAttribute('data-jr-mega-default') : null) ||
      detailsEl.querySelector('[data-jr-mega-l2]')?.getAttribute('data-jr-mega-l2') ||
      '';

    const currentActive =
      detailsEl.querySelector('[data-jr-mega-l2].is-active')?.getAttribute('data-jr-mega-l2') ||
      detailsEl.querySelector('[data-jr-mega-l2][aria-current="page"]')?.getAttribute('data-jr-mega-l2') ||
      '';

    activate(detailsEl, currentActive || defaultKey);
  };

  const closeDetails = (detailsEl) => {
    if (!isDesktop()) return;
    if (!(detailsEl instanceof HTMLDetailsElement)) return;
    if (detailsEl.contains(document.activeElement)) return;
    detailsEl.removeAttribute('open');
    updateOpenStateClass();
    const summary = detailsEl.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  };

  const init = () => {
    const menus = Array.from(document.querySelectorAll('details.jr-mega-menu[data-jr-mega-menu]')).filter(
      (x) => x instanceof HTMLDetailsElement
    );

    menus.forEach((detailsEl) => {
      const content = detailsEl.querySelector('.jr-mega-menu__content');
      if (!(content instanceof HTMLElement)) return;

      // Ensure only one L3 panel is visible by default.
      const defaultKey =
        content.getAttribute('data-jr-mega-default') ||
        detailsEl.querySelector('[data-jr-mega-l2]')?.getAttribute('data-jr-mega-l2') ||
        '';
      if (defaultKey) activate(detailsEl, defaultKey);

      let closeTimer = null;

      const cancelClose = () => {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = null;
      };

      const scheduleClose = () => {
        if (!isDesktop()) return;
        cancelClose();
        closeTimer = window.setTimeout(() => closeDetails(detailsEl), 160);
      };

      const summaryEl = detailsEl.querySelector('summary');
      const contentEl = content;

      if (summaryEl instanceof HTMLElement) {
        summaryEl.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          cancelClose();
          openDetails(detailsEl);
        });

        summaryEl.addEventListener('mouseleave', () => {
          scheduleClose();
        });

        summaryEl.addEventListener('focusin', () => {
          if (!isDesktop()) return;
          cancelClose();
          openDetails(detailsEl);
        });
      }

      if (contentEl instanceof HTMLElement) {
        contentEl.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          cancelClose();
          openDetails(detailsEl);
        });

        contentEl.addEventListener('mouseleave', () => {
          scheduleClose();
        });
      }

      detailsEl.addEventListener('toggle', () => {
        if (!isDesktop()) return;
        updateOpenStateClass();
        if (detailsEl.open) openDetails(detailsEl);
      });

      detailsEl.querySelectorAll('[data-jr-mega-l2]').forEach((el) => {
        el.addEventListener('click', (event) => {
          if (!(event instanceof MouseEvent)) return;
          if (!isDesktop()) return;

          const key = el.getAttribute('data-jr-mega-l2') || '';
          if (!key) return;

          const hasPanel = Array.from(detailsEl.querySelectorAll('[data-jr-mega-panel]')).some(
            (p) => p instanceof HTMLElement && (p.getAttribute('data-jr-mega-panel') || '') === key
          );

          if (!hasPanel) return;

          if (isFinePointer()) return;

          const alreadyActive = el.classList.contains('is-active');
          if (!alreadyActive) {
            event.preventDefault();
            activate(detailsEl, key);
          }
        });

        el.addEventListener('mouseenter', () => {
          if (!isDesktop()) return;
          const key = el.getAttribute('data-jr-mega-l2') || '';
          activate(detailsEl, key);
        });

        el.addEventListener('focus', () => {
          if (!isDesktop()) return;
          const key = el.getAttribute('data-jr-mega-l2') || '';
          activate(detailsEl, key);
        });
      });

      const l2List = detailsEl.querySelector('.jr-mega-menu__l2-list');
      if (l2List instanceof HTMLElement) {
        l2List.addEventListener('keydown', (event) => {
          if (!(event instanceof KeyboardEvent)) return;
          if (!isDesktop()) return;

          const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          const links = Array.from(l2List.querySelectorAll('[data-jr-mega-l2]')).filter((x) => x instanceof HTMLAnchorElement);
          if (links.length === 0) return;

          const activeEl = document.activeElement instanceof HTMLElement ? document.activeElement.closest('[data-jr-mega-l2]') : null;
          const idx = activeEl ? links.indexOf(activeEl) : -1;

          let nextIdx = idx;
          if (event.key === 'ArrowDown') nextIdx = Math.min(links.length - 1, (idx >= 0 ? idx + 1 : 0));
          if (event.key === 'ArrowUp') nextIdx = Math.max(0, (idx >= 0 ? idx - 1 : 0));
          if (event.key === 'Home') nextIdx = 0;
          if (event.key === 'End') nextIdx = links.length - 1;

          event.preventDefault();
          const next = links[nextIdx];
          next.focus();
          activate(detailsEl, next.getAttribute('data-jr-mega-l2') || '');
        });
      }
    });

    window.addEventListener('resize', scheduleHeaderVarsUpdate, { passive: true });
    window.addEventListener('scroll', scheduleHeaderVarsUpdate, { passive: true });
    updateOpenStateClass();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
